module.exports = __webpack_public_path__ + "media/images/golden_pin_design_award_img-6cbd6b5f69354159b4e4f401191ee362.jpg";